/** Hub URL aligned with REST API base; dev uses Vite proxy for cookie + WebSocket. */
export function resolveNotificationsHubUrl(): string {
  const base = (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/$/, '');
  if (import.meta.env.DEV && /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\/api$/i.test(base)) {
    return '/api/notifications';
  }
  return `${base}/notifications`;
}
